/*
* A function that given the proper type, identifiers
* and dataquery will return the formated data sdmxQuery
* 
* @memberOf SDMXJS
* @api public
* @tag parsing
* @param {Object}
* @return {String}
*
* @example
* const args = {
*   type: dataflow, //can also be 'availableconstraint'
*   identifiers: { agencyId: 'OECD', code: 'DF', version: '1.0' },
*   dataquery: '...'
* };
*
* SDMXJS.getDataRequestQuery(args);
* //=> 'data/OECD,DF,1.0/all',
*/
import { getUrlDataquery } from './getUrlDataquery';
export var getDataRequestQuery = function getDataRequestQuery(_ref) {
  var type = _ref.type,
    identifiers = _ref.identifiers,
    dataquery = _ref.dataquery;
  var agencyId = identifiers.agencyId,
    code = identifiers.code,
    _identifiers$version = identifiers.version,
    version = _identifiers$version === undefined ? '' : _identifiers$version;
  var dq = getUrlDataquery(dataquery);
  return type + '/' + agencyId + ',' + code + ',' + version + '/' + dq;
};